import AuthenticatedLayout from '@/components/layouts/AuthenticatedLayout'
import UserLayout from '@/components/layouts/UserLayout'
import { adminRoutes } from '@/pages/admin/routes'
import VisitorSecurityListPage from '@/pages/admin/visitors/VisitorSecurityListPage'
import { authRoutes } from '@/pages/auth/routes'
import Exception403 from '@/pages/exceptions/403'
import Exception404 from '@/pages/exceptions/404'
import Exception500 from '@/pages/exceptions/500'
import { userRoutes } from '@/pages/user/routes'
import AdminRoute from '@/routes/AdminRoute'
import ProtectedRoute from '@/routes/ProtectedRoute'
import RedirectToDashboard from '@/routes/RedirectToDashboard'
import Root from '@/routes/root'
import React, { lazy, Suspense } from 'react'
import { RouteObject } from 'react-router-dom'

const PricingPage = lazy(() => import('@/pages/pricing/PricingPage'))

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Root />,
    children: [
      {
        index: true,
        element: <RedirectToDashboard />,
      },
      {
        path: 'pricing',
        element: (
          <Suspense fallback={null}>
            <PricingPage />
          </Suspense>
        ),
      },
      ...authRoutes,
      {
        element: <AuthenticatedLayout />,
        children: [
          {
            path: 'admin',
            element: (
              <AdminRoute
                element={
                  <Suspense fallback={null}>
                    {React.createElement(
                      lazy(() => import('@/components/layouts/AdminLayout'))
                    )}
                  </Suspense>
                }
              />
            ),

            children: adminRoutes,
          },
          {
            path: 'user',
            element: <ProtectedRoute element={<UserLayout />} />,
            children: userRoutes,
          },
        ],
      },
      {
        path: 'security/visitors',
        element: <VisitorSecurityListPage />,
      },
      {
        path: 'exceptions',
        children: [
          {
            path: '403',
            element: <Exception403 />,
          },
          {
            path: '404',
            element: <Exception404 />,
          },
          {
            path: '500',
            element: <Exception500 />,
          },
        ],
      },
      {
        path: '*',
        element: <Exception404 />,
      },
    ],
  },
]

export default routes
